<!-- 绑定手机号 -->
<template>
	<div class="wrap">

		<div class="top">
			首页
			<img src="../../assets/icon-7.png" class="top-icon">
			<span>设置</span>
			<img src="../../assets/icon-7.png" class="top-icon">
			<span class="top-name">绑定手机号</span>
		</div>

		<div class="container">

			<div class="leftsidebar">
				<a href="javascript:void(0)" @click="$router.push('/my/my-order')">我的订单</a>
				<a href="javascript:void(0)" @click="$router.push('/shopping-cart')">我的购物车</a>
				<a href="javascript:void(0)" @click="$router.push('/my/browsing-history')">浏览记录</a>
				<a href="javascript:void(0)" @click="$router.push('/my/my-collection')">我的收藏</a>
				<a href="javascript:void(0)" @click="$router.push('/my/my-points')">我的积分</a>
				<a href="javascript:void(0)" @click="$router.push('/my/my-member')">我的会员</a>
				<a href="javascript:void(0)" @click="$router.push('/my/card-voucher')">卡券</a>
				<a href="javascript:void(0)" @click="$router.push('/my/message')">消息</a>
				<a href="javascript:void(0)" @click="$router.push('/my/partner')">携手合伙人</a>
				<a href="javascript:void(0)">签到奖励</a>
				<a href="javascript:void(0)" @click="$router.push('/my/my-distribution')">我的分销</a>
				<a href="javascript:void(0)" @click="$router.push('/my/product-traceability')">产品溯源</a>
				<a href="javascript:void(0)" @click="$router.push('/my/my-appointment')">我的预约</a>
				<a href="javascript:void(0)" @click="$router.push('/my/feedback')">意见反馈</a>
				<a href="javascript:void(0)" @click="$router.push('/my/information-material')">资讯素材</a>
				<!-- <a href="javascript:void(0)">在线客服</a> -->
				<a href="javascript:void(0)" @click="$router.push('/my/set-up')" class="active">设置<img
						src="../../assets/sanjiao.png" class="sanjiao"></a>
			</div>

			<div class="rightsidebar">
				<div class="box">
					<p class="box-label">
						绑定手机号
					</p>
					<el-form ref="form" label-width="80px" size="mini">

						<div class="form-row">
							<span class="form-label"><span>*</span>已绑定手机号</span>
							<div class="right-sidebar">
								<div class="small-box">
									<el-form-item style="width: 100%;">
										<el-input v-model="info.showPhone" disabled placeholder="请输入手机号"></el-input>
									</el-form-item>
								</div>
							</div>
						</div>

						<div class="form-row">
							<span class="form-label"><span>*</span>手机号</span>
							<div class="right-sidebar">
								<div class="small-box">
									<el-form-item style="width: 100%;">
										<el-input v-model="params.phone" placeholder="请输入手机号"></el-input>
									</el-form-item>
								</div>
							</div>
						</div>

						<div class="form-row">
							<span class="form-label"><span>*</span>验证码</span>
							<div class="right-sidebar">
								<div class="small-box">
									<el-form-item style="width: 100%;">
										<el-input v-model="params.code" placeholder="验证码"></el-input>
									</el-form-item>
								</div>
								<button v-if="countDown <= 0" @click="sendSms()" type="button"
									class="get-code">获取验证码</button>
								<button v-else type="button" class="get-code">{{countDown}}秒后重发</button>
							</div>
						</div>

						<div class="btn-box">
							<button type="button" class="active" @click="modifyPhone()">绑定</button>
							<button type="button" class="border-btn">取消</button>
						</div>

					</el-form>
				</div>
			</div>

		</div>

	</div>
</template>

<script>
	import {
		validatorFun
	} from '../../utils/util';
	import {
		generalSendSms,
		userCenterModifyPhone
	} from '../../service/service';
	export default {
		components: {
		},
		data() {
			return {
				form: {
					now_number: '16634567866',
					number: '',
					num: '',
				},
				info: {},
				params: {
					phone: '',
					code: '',
				},
				countDown: 0,
			};
		},
		mounted() {
			this.info = JSON.parse(localStorage.getItem('USER_INFO') || '{}');
			this.info.showPhone = this.info.phone.split('').map((n, i) => i > 2 && i < 7 ? '*' : n).join('');
		},
		methods: {
			modifyPhone() {
				const params = this.params;
				const errList = validatorFun(params, [
					['phone', ['notNull', '请输入手机号'],
						['isMobile', '请输入正确手机号']
					],
					['code', ['notNull', '请输入验证码']],
				]);
				if (errList.length > 0) {
					return this.$message.error(errList[0].errMsg);
				}
				userCenterModifyPhone(params).then(({
					code,
					msg,
					data
				}) => {
					if (code == 1) {
						this.info.phone = params.phone;
						localStorage.setItem('USER_INFO', JSON.stringify(info));
						this.params = {
							phone: '',
							code: '',
						};
						this.$confirm('修改成功，请重新登录', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							showCancelButton: false,
							type: 'warning',
						}).then(() => {
							localStorage.removeItem('session_key');
							localStorage.removeItem('USER_INFO');
							this.$router.push('/login');
						});
					} else {
						this.$message.error(msg);
					}
				});
			},
			sendSms() {
				const params = this.params;
				const errList = validatorFun(params, [
					['phone', ['notNull', '请输入手机号'],
						['isMobile', '请输入正确手机号']
					],
				]);
				if (errList.length > 0) {
					return this.$message.error(errList[0].errMsg);
				}
				generalSendSms({
					phone: params.phone,
				}).then(({
					code,
					msg,
					data
				}) => {
					if (code == 1) {
						this.countDownFn();
						this.$message.success(msg);
					} else {
						this.$message.error(msg);
					}
				});
			},
			countDownFn() {
				let num = 60;
				const fn = () => {
					if (num == 0) return;
					this.countDown = --num;
					setTimeout(() => fn(), 1000);
				};
				fn();
			},
		}
	}
</script>

<style scoped>
	input::placeholder,
	textarea::placeholder {
		color: #BBBBBB !important;
	}

	.wrap {
		width: 100%;
		margin: 40px 0 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.top {
		width: 1200px;
		height: 76px;
		line-height: 76px;
		background-color: #FFFFFF;
		border-radius: 8px;
		display: flex;
		align-items: center;
		padding: 0 19px;
		box-sizing: border-box;
		color: #484848;
		font-size: 20px;
		margin: 20px 0;
	}

	.top-icon {
		width: 10px;
		margin: 0 10px;
	}

	.top-name {
		color: #F2501A;
	}

	.container {
		width: 1200px;
		display: flex;
		align-items: flex-start;
		margin-bottom: 43px;
	}

	.leftsidebar {
		width: 144px;
		padding: 21px 0 28px;
		display: flex;
		flex-direction: column;
		background-color: #FFFFFF;
		border-radius: 8px;
		margin-right: 19px;
	}

	.leftsidebar>a {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 20px;
		padding: 0 0 0 29px;
		box-sizing: border-box;
		color: #000000;
		font-size: 16px;
		position: relative;
	}

	.leftsidebar>a.active {
		color: #F2501A;
		font-size: 18px;
	}

	.leftsidebar>a.active::after {
		content: "";
		position: absolute;
		left: 0;
		top: 50%;
		transform: translate(0, -50%);
		width: 4px;
		height: 26px;
		background: url(../../assets/border.png) no-repeat;
		background-size: 100% 100%;
	}

	.sanjiao {
		width: 14px;
		margin-left: 10px;
	}

	.rightsidebar {
		width: calc(100% - 163px);
		display: flex;
		flex-direction: column;
	}

	.box {
		width: 100%;
		background-color: #FFFFFF;
		border-radius: 8px;
		padding: 28px 31px 41px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
	}

	.box-label {
		width: 100%;
		display: flex;
		flex-direction: column;
		color: #111111;
		font-size: 17px;
		font-weight: bold;
		margin-bottom: 42px;
	}

	.box-label>span {
		font-size: 14px;
		font-weight: normal;
		margin-top: 5px;
	}

	.form-row {
		width: 100%;
		display: flex;
		align-items: flex-start;
		padding: 0 8px;
		box-sizing: border-box;
		margin-bottom: 34px;
	}

	.form-row:last-child {
		margin-bottom: 0;
	}

	.form-label {
		width: 120px;
		line-height: 30px;
		color: #111111;
		font-size: 16px;
	}

	.form-label>span {
		color: #F91F1D;
		margin-right: 7px;
	}

	.btn-box {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 0 0 0 128px;
		box-sizing: border-box;
	}

	.btn-box button {
		width: 213px;
		height: 45px;
		line-height: 45px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #EEEEEE;
		border-radius: 8px;
		color: #777777;
		font-size: 17px;
		margin-right: 18px;
	}

	.btn-box button:last-child {
		margin-right: 0;
	}

	.btn-box button.active {
		background-color: #F2501A;
		color: #fff;
	}

	.border-btn {
		border: 1px solid #E63D23 !important;
		background-color: #FFFFFF !important;
		box-sizing: border-box;
		color: #F2501A !important;
	}

	.big-box {
		display: flex;
		width: 549px;
	}

	.small-box {
		display: flex;
		width: 234px;
	}

	.form-bottom {
		width: 549px;
		display: flex;
		align-items: flex-start;
		margin-left: 128px;
		margin-bottom: 38px;
		color: #000000;
		font-size: 16px;
	}

	.red-color {
		color: #F2501A;
	}

	input[type="checkbox"] {
		width: 15px !important;
		height: 15px !important;
		vertical-align: middle;
		-webkit-appearance: none;
		background: url(../../assets/square.png) no-repeat center center;
		background-size: 100% 100%;
		margin-right: 5px;
		margin-top: 3.5px;
	}

	input[type="checkbox"]:checked {
		background: url(../../assets/square-active.png) no-repeat center center;
		background-size: 100% 100%;
	}

	.customer-service {
		display: flex;
		align-items: center;
		color: #F2501A;
		font-size: 13px;
		margin-left: 15px;
	}

	.customer-service img {
		width: 15px;
		margin-right: 3px;
	}

	.right-sidebar {
		flex: 1;
		display: flex;
		align-items: center;
	}

	.get-code {
		margin-left: 20px;
		width: 111px;
		height: 30px;
		line-height: 30px;
		background-color: #F2501A;
		border-radius: 4px;
		color: #FFFFFF;
		font-size: 16px;
	}

	>>>.el-form-item__content {
		margin: 0 !important;
	}

	>>>.el-form-item {
		margin-right: 13px !important;
		margin-bottom: 0 !important;
	}

	>>>.el-form-item:last-child {
		margin-right: 0 !important;
	}

	.el-select>>>.el-input__inner:focus {
		border-color: #BBBBBB !important;
	}

	>>>.el-input__inner {
		height: 30px !important;
		line-height: 30px !important;
		border: 1px solid #BBBBBB !important;
		color: #434849;
		font-size: 16px !important;
	}

	>>>.el-textarea__inner {
		height: 199px !important;
		border: 1px solid #BBBBBB !important;
		color: #434849;
		font-size: 16px;
	}
</style>
